import React from "react";
import { mobileSoftwareServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const MobileSoftwareServiceDetailPage = () => {
  const mobileData = mobileSoftwareServiceData;
  return (
    <>
      <SEO {...seoData.mobileSoftware} />
      <ServiceDetailsInner data={mobileData} />
    </>
  );
};

export default MobileSoftwareServiceDetailPage;
